import { LIST_PAGINATION_MODEL, LIST_SUMMARY_MODEL } from '../../app/models';

/**
 *  상품 문의 리스트 필터 옵션 모델
 */
export const CS_QNA_LIST_FILTER_OPTION_MODEL = {
  /**
   *  상품 문의 ID
   */
  id: null,
  /**
   *  답변 처리 상태
   */
  isResponse: null,
  /**
   *  상태
   */
  status: null,
  /**
   *  상품번호
   */
  productId: null,
  /**
   *  상품명
   */
  productName: null,
  /**
   *  상점명
   */
  storeName: null,
  /**
   *  상점 ID
   */
  storeId: null,
  /**
   *  오늘 출발 여부
   */
  isTodayDelivery: null,
  /**
   *  문의자 ID
   */
  userAccount: null,
  /**
   *  문의자명
   */
  userName: null,
  /**
   *  질문내용
   */
  question: null,
  /**
   *  답변내용
   */
  answer: null,
  /**
   *  답변 작성자
   */
  replyAuthor: null,
  /**
   *  답변 작성자 메모
   */
  memo: null,
  /**
   *  답변 일자
   */
  answerDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  문의 작성 일자
   */
  createDate: {
    startDate: null,
    endDate: null,
  },
  /**
   *  주문여부
   */
  isOrderQna: null,
  /**
   *  주문상태
   */
  orderItemStatus: null,
};

/**
 *  상품 문의 리스트 필터 옵션 모델
 */
export const CS_QNA_LIST_SORT_OPTION_MODEL = [
  {
    id: 'createDate',
    desc: true,
  },
];

/**
 *  상품 문의 상세 상품 정보 모델
 */
export const CS_QNA_DETAIL_PRODUCT_INFO_MODEL = {
  /**
   *  상품 번호
   */
  productId: null,
  /**
   *  카테고리
   */
  category: null,
  /**
   *  상품명
   */
  productName: null,
  /**
   *  상점명
   */
  storeName: null,
  /**
   *  상점 식별 id
   */
  storeId: null,
  /**
   *  상점 전화번호
   */
  storeCellPhone: null,
  /**
   *  판매자 전화번호
   */
  sellerCellPhone: null,
  /**
   *  상점 티어
   */
  storeTier: null,
  /**
   *  판매가
   */
  originPrice: null,
  /**
   *  상품 할인액
   */
  discountPrice: null,
  /**
   *  실판매가
   */
  salesPrice: null,
  /**
   *  할인기간
   */
  discountPeriod: null,
  /**
   *  상태
   */
  status: null,
  /**
   *  등록일
   */
  createDate: null,
  /**
   *  상품 이미지
   */
  images: [],
};

/**
 *  상품 문의 상세 문의 정보 모델
 */
export const CS_QMA_DETAIL_QNA_INFO_MODEL = {
  /**
   *  QnA ID
   */
  qnaId: null,
  /**
   *  문의 접수일
   */
  createDate: null,
  /**
   *  답변 일자
   */
  answerDate: null,
  /**
   *  답변까지 걸린 시간
   */
  timeReply: null,
  /**
   *  유저 계정
   */
  userAccount: null,
  /**
   *  유저 식별 id
   */
  userId: null,
  /**
   *  문의자명
   */
  userName: null,
  /**
   *  문의자 이메일
   */
  userEmail: null,
  /**
   *  문의자 전화번호
   */
  userCellPhone: null,
  /**
   *  상태
   */
  status: null,
  /**
   *  문의내용
   */
  question: null,
  /**
   *  답변
   */
  answer: null,
  /**
   *  답변 작성자
   */
  replyAuthor: null,
  /**
   *  메모
   */
  memo: null,
  /**
   *  이전 문의 목록 조회
   */
  usersOtherQna: {
    /**
     *  리스트
     */
    list: [],
    /**
     *  리스트 pagination
     */
    pagination: LIST_PAGINATION_MODEL,
    /**
     *  집계 데이터
     */
    summary: LIST_SUMMARY_MODEL,
  },
  /**
   *  주문여부
   */
  isOrderQna: null,
  /**
   *  주문상태
   */
  orderItemStatus: null,
  /**
   *  비밀글 여부
   */
  isSecret: null,
};
